import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = (n) => (_pushScopeId("data-v-1b926c9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "header navbar-area sticky",
    ref: "headerRef"
};
const _hoisted_2 = { class: "header-middle" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row align-items-center" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-lg-3 col-md-3 col-7" }, [
    /*#__PURE__*/ _createCommentVNode(" Start Header Logo "),
    /*#__PURE__*/ _createElementVNode("a", {
        class: "navbar-brand",
        href: "/"
    }, [
        /*#__PURE__*/ _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo"
        })
    ]),
    /*#__PURE__*/ _createCommentVNode(" End Header Logo ")
], -1 /* HOISTED */));
const _hoisted_6 = { class: "col-lg-5 col-md-7 d-none d-md-block" };
const _hoisted_7 = { class: "main-menu-search" };
const _hoisted_8 = { class: "navbar-search search-style-5" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "search-select" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "select-position" }, [
        /*#__PURE__*/ _createElementVNode("select", { id: "select1" }, [
            /*#__PURE__*/ _createElementVNode("option", { selected: "" }, "Todas")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_10 = { class: "search-input" };
const _hoisted_11 = { class: "search-btn" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-search-alt" }, null, -1 /* HOISTED */));
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = { class: "col-lg-4 col-md-2 col-5" };
const _hoisted_15 = { class: "middle-right-area" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "nav-hotline" }, null, -1 /* HOISTED */));
const _hoisted_17 = { class: "navbar-cart" };
const _hoisted_18 = {
    key: 0,
    class: "cart-items"
};
const _hoisted_19 = {
    href: "javascript:void(0)",
    class: "main-btn"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart" }, null, -1 /* HOISTED */));
const _hoisted_21 = { class: "total-items" };
const _hoisted_22 = {
    key: 0,
    class: "shopping-item"
};
const _hoisted_23 = { class: "dropdown-cart-header" };
const _hoisted_24 = { class: "cart-links" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", { href: "/checkout" }, "Ver Carrito", -1 /* HOISTED */));
const _hoisted_26 = { class: "shopping-list" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-close" }, null, -1 /* HOISTED */));
const _hoisted_29 = [
    _hoisted_28
];
const _hoisted_30 = { class: "cart-img-head" };
const _hoisted_31 = {
    class: "cart-img",
    href: "product-details.html"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = { class: "content" };
const _hoisted_34 = { href: "product-details.html" };
const _hoisted_35 = { class: "quantity-control" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-minus" }, null, -1 /* HOISTED */));
const _hoisted_38 = [
    _hoisted_37
];
const _hoisted_39 = ["onUpdate:modelValue", "onInput"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-plus" }, null, -1 /* HOISTED */));
const _hoisted_42 = [
    _hoisted_41
];
const _hoisted_43 = { class: "quantity" };
const _hoisted_44 = { class: "amount" };
const _hoisted_45 = { class: "pagination" };
const _hoisted_46 = ["disabled"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = { class: "bottom" };
const _hoisted_49 = { class: "total" };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Total", -1 /* HOISTED */));
const _hoisted_51 = { class: "total-amount" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "button" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/checkout",
        class: "btn animate"
    }, "Ir a Pagar")
], -1 /* HOISTED */));
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-user icon" })
], -1 /* HOISTED */));
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "logout-arrow" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-chevron-down" })
], -1 /* HOISTED */));
const _hoisted_55 = {
    key: 0,
    class: "dropdown-menu"
};
const _hoisted_56 = { class: "profile-card" };
const _hoisted_57 = { class: "profile-img" };
const _hoisted_58 = ["src"];
const _hoisted_59 = { class: "profile-info" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "/perfil",
    class: "dropdown-item"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-user" }),
    /*#__PURE__*/ _createTextVNode("  Perfil ")
], -1 /* HOISTED */));
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "/mis-pedidos",
    class: "dropdown-item"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-shopping-basket" }),
    /*#__PURE__*/ _createTextVNode("  Mis Pedidos ")
], -1 /* HOISTED */));
const _hoisted_62 = {
    key: 0,
    href: "/panel",
    class: "dropdown-item"
};
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-grid-alt" }, null, -1 /* HOISTED */));
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-exit" }, null, -1 /* HOISTED */));
const _hoisted_65 = { class: "login ms-4" };
const _hoisted_66 = { class: "auth-buttons" };
const _hoisted_67 = {
    href: "/login",
    class: "auth-button auth-login"
};
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "button-text" }, "Inicia sesión", -1 /* HOISTED */));
const _hoisted_69 = { class: "container" };
const _hoisted_70 = { class: "row align-items-center" };
const _hoisted_71 = { class: "col-lg-8 col-md-6 col-12" };
const _hoisted_72 = { class: "nav-inner" };
const _hoisted_73 = /*#__PURE__*/ _createStaticVNode("<div class=\"mega-category-menu\" data-v-1b926c9f><span class=\"cat-button\" data-v-1b926c9f><i class=\"lni lni-menu\" data-v-1b926c9f></i>Todas las Categorias </span><ul class=\"sub-category\" data-v-1b926c9f><li data-v-1b926c9f><a href=\"product-grids.html\" data-v-1b926c9f>Accesorios Motero</a></li><li data-v-1b926c9f><a href=\"product-grids.html\" data-v-1b926c9f>Accesorios Moto</a></li></ul></div>", 1);
const _hoisted_74 = { class: "navbar navbar-expand-lg" };
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "navbar-toggler mobile-menu-btn",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#navbarSupportedContent",
    "aria-controls": "navbarSupportedContent",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation"
}, [
    /*#__PURE__*/ _createElementVNode("span", { class: "toggler-icon" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "toggler-icon" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "toggler-icon" })
], -1 /* HOISTED */));
const _hoisted_76 = { class: "col-8 d-block d-sm-none" };
const _hoisted_77 = { class: "mobile-search" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-search-alt" }, null, -1 /* HOISTED */));
const _hoisted_79 = [
    _hoisted_78
];
const _hoisted_80 = /*#__PURE__*/ _createStaticVNode("<div class=\"collapse navbar-collapse sub-menu-bar\" id=\"navbarSupportedContent\" data-v-1b926c9f><ul id=\"nav\" class=\"navbar-nav ms-auto\" data-v-1b926c9f><li class=\"nav-item\" data-v-1b926c9f><a href=\"/\" aria-label=\"Toggle navigation\" data-v-1b926c9f>Inicio</a></li><li class=\"nav-item\" data-v-1b926c9f><a href=\"/productos\" aria-label=\"Toggle navigation\" data-v-1b926c9f>Productos</a></li><li class=\"nav-item\" data-v-1b926c9f><a href=\"/contacto\" aria-label=\"Toggle navigation\" data-v-1b926c9f>Contacto</a></li></ul></div>", 1);
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-lg-4 col-md-6 col-12" }, null, -1 /* HOISTED */));
const _hoisted_82 = {
    key: 0,
    class: "total-items"
};
const _hoisted_83 = {
    key: 0,
    class: "shopping-item"
};
const _hoisted_84 = { class: "dropdown-cart-header" };
const _hoisted_85 = { class: "cart-links" };
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", { href: "/checkout" }, "Ver Carrito", -1 /* HOISTED */));
const _hoisted_87 = { class: "shopping-list" };
const _hoisted_88 = ["onClick"];
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-close me-2" }, null, -1 /* HOISTED */));
const _hoisted_90 = [
    _hoisted_89
];
const _hoisted_91 = { class: "cart-img-head" };
const _hoisted_92 = {
    class: "cart-img",
    href: "product-details.html"
};
const _hoisted_93 = ["src"];
const _hoisted_94 = { class: "content" };
const _hoisted_95 = { href: "product-details.html" };
const _hoisted_96 = { class: "quantity-control" };
const _hoisted_97 = ["onClick"];
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-minus" }, null, -1 /* HOISTED */));
const _hoisted_99 = [
    _hoisted_98
];
const _hoisted_100 = ["onUpdate:modelValue", "onInput", "onKeyup", "id"];
const _hoisted_101 = ["onClick"];
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-plus" }, null, -1 /* HOISTED */));
const _hoisted_103 = [
    _hoisted_102
];
const _hoisted_104 = { class: "quantity" };
const _hoisted_105 = { class: "amount" };
const _hoisted_106 = { class: "pagination" };
const _hoisted_107 = ["disabled"];
const _hoisted_108 = ["disabled"];
const _hoisted_109 = { class: "bottom" };
const _hoisted_110 = { class: "total" };
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Total", -1 /* HOISTED */));
const _hoisted_112 = { class: "total-amount" };
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "button" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/checkout",
        class: "btn"
    }, "Ir a Pagar")
], -1 /* HOISTED */));
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { id: "header-placeholder" }, null, -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_User2Icon = _resolveComponent("User2Icon");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" Start Header Area "),
        _createElementVNode("header", _hoisted_1, [
            _createCommentVNode(" Start Header Middle "),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                            _createCommentVNode(" Start Main Menu Search "),
                            _createElementVNode("div", _hoisted_7, [
                                _createCommentVNode(" navbar search start "),
                                _createElementVNode("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("div", _hoisted_10, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            placeholder: "Buscar...",
                                            onKeyup: _cache[0] || (_cache[0] = _withKeys(
                                            //@ts-ignore
                                            (...args) => ($setup.performSearch && $setup.performSearch(...args)), ["enter"])),
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.searchQuery) = $event))
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelText, $setup.searchQuery]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("button", {
                                            onClick: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => ($setup.performSearch && $setup.performSearch(...args)))
                                        }, _hoisted_13)
                                    ])
                                ]),
                                _createCommentVNode(" navbar search Ends ")
                            ]),
                            _createCommentVNode(" End Main Menu Search ")
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("div", _hoisted_17, [
                                    ($setup.user)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("a", _hoisted_19, [
                                                _hoisted_20,
                                                _createElementVNode("span", _hoisted_21, _toDisplayString($setup.cartItems.length), 1 /* TEXT */)
                                            ]),
                                            _createCommentVNode(" Shopping Item "),
                                            ($setup.cartItems.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("span", null, _toDisplayString($setup.cartItems.length) + " " + _toDisplayString($setup.cartItems.length === 1 ? 'Item' : 'Items'), 1 /* TEXT */),
                                                        _createElementVNode("div", _hoisted_24, [
                                                            _createElementVNode("a", {
                                                                href: "#",
                                                                onClick: _cache[3] || (_cache[3] = _withModifiers(
                                                                //@ts-ignore
                                                                (...args) => ($setup.vaciarCarrito && $setup.vaciarCarrito(...args)), ["prevent"]))
                                                            }, "Vaciar"),
                                                            _hoisted_25
                                                        ])
                                                    ]),
                                                    _createElementVNode("ul", _hoisted_26, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedCartItems, (item) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: item.detalleCarritoID
                                                            }, [
                                                                _createElementVNode("a", {
                                                                    href: "javascript:void(0)",
                                                                    class: "remove",
                                                                    title: "Remove this item",
                                                                    onClick: ($event) => ($setup.removeItem(item.detalleCarritoID))
                                                                }, _hoisted_29, 8 /* PROPS */, _hoisted_27),
                                                                _createElementVNode("div", _hoisted_30, [
                                                                    _createElementVNode("a", _hoisted_31, [
                                                                        _createElementVNode("img", {
                                                                            src: $setup.getPortadaImage(item.producto.imagenes),
                                                                            alt: "#"
                                                                        }, null, 8 /* PROPS */, _hoisted_32)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_33, [
                                                                    _createElementVNode("h4", null, [
                                                                        _createElementVNode("a", _hoisted_34, _toDisplayString(item.producto.repuesto.nombre), 1 /* TEXT */)
                                                                    ]),
                                                                    _createCommentVNode(" Estilo mejorado para los botones de cantidad "),
                                                                    _createElementVNode("div", _hoisted_35, [
                                                                        _createElementVNode("button", {
                                                                            class: "quantity-btn",
                                                                            onClick: ($event) => ($setup.decrementQuantity(item.detalleCarritoID))
                                                                        }, _hoisted_38, 8 /* PROPS */, _hoisted_36),
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "number",
                                                                            class: "quantity-input",
                                                                            "onUpdate:modelValue": ($event) => ((item.cantidad) = $event),
                                                                            onInput: ($event) => ($setup.updateQuantity(item)),
                                                                            min: "1"
                                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_39), [
                                                                            [
                                                                                _vModelText,
                                                                                item.cantidad,
                                                                                void 0,
                                                                                { number: true }
                                                                            ]
                                                                        ]),
                                                                        _createElementVNode("button", {
                                                                            class: "quantity-btn",
                                                                            onClick: ($event) => ($setup.incrementQuantity(item.detalleCarritoID))
                                                                        }, _hoisted_42, 8 /* PROPS */, _hoisted_40)
                                                                    ]),
                                                                    _createElementVNode("p", _hoisted_43, [
                                                                        _createTextVNode(_toDisplayString(item.cantidad) + "x - ", 1 /* TEXT */),
                                                                        _createElementVNode("span", _hoisted_44, _toDisplayString($setup.formatCurrency(item.producto.precioVenta)), 1 /* TEXT */)
                                                                    ])
                                                                ])
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _createCommentVNode(" Controles de Paginación "),
                                                    _createElementVNode("div", _hoisted_45, [
                                                        _createElementVNode("button", {
                                                            class: "pagination-button",
                                                            onClick: _cache[4] || (_cache[4] =
                                                                //@ts-ignore
                                                                (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                                                            disabled: $setup.currentPage === 1
                                                        }, "Anterior", 8 /* PROPS */, _hoisted_46),
                                                        _createElementVNode("span", null, "Página " + _toDisplayString($setup.currentPage) + " de " + _toDisplayString($setup.totalPages), 1 /* TEXT */),
                                                        _createElementVNode("button", {
                                                            class: "pagination-button",
                                                            onClick: _cache[5] || (_cache[5] =
                                                                //@ts-ignore
                                                                (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                                                            disabled: $setup.currentPage === $setup.totalPages
                                                        }, "Siguiente", 8 /* PROPS */, _hoisted_47)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_48, [
                                                        _createElementVNode("div", _hoisted_49, [
                                                            _hoisted_50,
                                                            _createElementVNode("span", _hoisted_51, _toDisplayString($setup.totalAmount) + " $", 1 /* TEXT */)
                                                        ]),
                                                        _hoisted_52
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createCommentVNode("/ End Shopping Item ")
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    ($setup.user)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "account",
                                            onMouseover: _cache[7] || (_cache[7] = ($event) => ($setup.showMenu = true)),
                                            onMouseleave: _cache[8] || (_cache[8] = ($event) => ($setup.showMenu = false))
                                        }, [
                                            _hoisted_53,
                                            _hoisted_54,
                                            _createCommentVNode(" Menú desplegable "),
                                            ($setup.showMenu)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                    _createElementVNode("div", _hoisted_56, [
                                                        _createElementVNode("div", _hoisted_57, [
                                                            _createElementVNode("img", {
                                                                src: $setup.profileImage,
                                                                alt: "Profile Image"
                                                            }, null, 8 /* PROPS */, _hoisted_58)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_59, [
                                                            _createElementVNode("h4", null, _toDisplayString($setup.user.nombre), 1 /* TEXT */),
                                                            _createElementVNode("p", null, _toDisplayString($setup.user.role === "1" ? "Vendedor" : "Comprador"), 1 /* TEXT */)
                                                        ])
                                                    ]),
                                                    _hoisted_60,
                                                    _hoisted_61,
                                                    ($setup.hasPermission('PANEL_VIEW'))
                                                        ? (_openBlock(), _createElementBlock("a", _hoisted_62, [
                                                            _hoisted_63,
                                                            _createTextVNode("  Panel ")
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createElementVNode("a", {
                                                        href: "javascript:void(0)",
                                                        onClick: _cache[6] || (_cache[6] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.logout && $setup.logout(...args))),
                                                        class: "dropdown-item"
                                                    }, [
                                                        _hoisted_64,
                                                        _createTextVNode("  Cerrar Sesión ")
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ], 32 /* NEED_HYDRATION */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createCommentVNode(" Botón para iniciar sesión cuando no hay usuario "),
                                            _createElementVNode("div", _hoisted_65, [
                                                _createCommentVNode(" Contenedor para los botones de iniciar sesión y registrarse "),
                                                _createElementVNode("div", _hoisted_66, [
                                                    _createElementVNode("a", _hoisted_67, [
                                                        _createVNode(_component_User2Icon, {
                                                            size: $setup.iconSize,
                                                            class: "icon"
                                                        }, null, 8 /* PROPS */, ["size"]),
                                                        _hoisted_68
                                                    ])
                                                ])
                                            ])
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _createCommentVNode(" End Header Middle "),
            _createCommentVNode(" Start Header Bottom "),
            _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                            _createCommentVNode(" Start Mega Category Menu "),
                            _hoisted_73,
                            _createCommentVNode(" End Mega Category Menu "),
                            _createCommentVNode(" Start Navbar "),
                            _createElementVNode("nav", _hoisted_74, [
                                _hoisted_75,
                                _createCommentVNode(" Buscador SOLO en móviles "),
                                _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "search-input-mobile",
                                            placeholder: "Buscar...",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (($setup.searchQuery) = $event)),
                                            onKeyup: _cache[10] || (_cache[10] = _withKeys(
                                            //@ts-ignore
                                            (...args) => ($setup.performSearch && $setup.performSearch(...args)), ["enter"]))
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelText, $setup.searchQuery]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "search-btn-mobile",
                                            onClick: _cache[11] || (_cache[11] =
                                                //@ts-ignore
                                                (...args) => ($setup.performSearch && $setup.performSearch(...args)))
                                        }, _hoisted_79)
                                    ])
                                ]),
                                _hoisted_80,
                                _createCommentVNode(" navbar collapse ")
                            ]),
                            _createCommentVNode(" End Navbar ")
                        ])
                    ]),
                    _hoisted_81
                ])
            ]),
            _createCommentVNode(" End Header Bottom "),
            ($setup.user)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['floating-cart', { active: $setup.isCartOpen }])
                }, [
                    _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "main-btn",
                        onClick: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => ($setup.toggleCart && $setup.toggleCart(...args)))
                    }, [
                        _createElementVNode("i", {
                            class: _normalizeClass($setup.isCartOpen ? 'lni lni-shopping-basket' : 'lni lni-cart')
                        }, null, 2 /* CLASS */),
                        (!$setup.isCartOpen)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString($setup.cartItems.length), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" Shopping Item "),
                    ($setup.cartItems.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("span", null, _toDisplayString($setup.cartItems.length) + " " + _toDisplayString($setup.cartItems.length === 1 ? 'Item' : 'Items'), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("a", {
                                        href: "#",
                                        onClick: _cache[13] || (_cache[13] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.vaciarCarrito && $setup.vaciarCarrito(...args)), ["prevent"]))
                                    }, "Vaciar"),
                                    _hoisted_86
                                ])
                            ]),
                            _createElementVNode("ul", _hoisted_87, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedCartItems2, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: item.detalleCarritoID
                                    }, [
                                        _createElementVNode("a", {
                                            href: "javascript:void(0)",
                                            class: "remove",
                                            onClick: ($event) => ($setup.removeItem(item.detalleCarritoID))
                                        }, _hoisted_90, 8 /* PROPS */, _hoisted_88),
                                        _createElementVNode("div", _hoisted_91, [
                                            _createElementVNode("a", _hoisted_92, [
                                                _createElementVNode("img", {
                                                    src: $setup.getPortadaImage(item.producto.imagenes),
                                                    alt: "#"
                                                }, null, 8 /* PROPS */, _hoisted_93)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_94, [
                                            _createElementVNode("h4", null, [
                                                _createElementVNode("a", _hoisted_95, _toDisplayString(item.producto.repuesto.nombre), 1 /* TEXT */)
                                            ]),
                                            _createCommentVNode(" Estilo mejorado para los botones de cantidad "),
                                            _createElementVNode("div", _hoisted_96, [
                                                _createElementVNode("button", {
                                                    class: "quantity-btn",
                                                    onClick: ($event) => ($setup.decrementQuantity(item.detalleCarritoID))
                                                }, _hoisted_99, 8 /* PROPS */, _hoisted_97),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "quantity-input",
                                                    "onUpdate:modelValue": ($event) => ((item.cantidad) = $event),
                                                    onInput: ($event) => ($setup.updateQuantity(item)),
                                                    onKeyup: _withKeys(($event) => ($setup.focusNextQuantity(index)), ["enter"]),
                                                    id: 'quantity-' + index
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_100), [
                                                    [
                                                        _vModelText,
                                                        item.cantidad,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "quantity-btn",
                                                    onClick: ($event) => ($setup.incrementQuantity(item.detalleCarritoID))
                                                }, _hoisted_103, 8 /* PROPS */, _hoisted_101)
                                            ]),
                                            _createElementVNode("p", _hoisted_104, [
                                                _createTextVNode(_toDisplayString(item.cantidad) + "x - ", 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_105, _toDisplayString($setup.formatCurrency(item.producto.precioVenta)), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createCommentVNode(" Controles de Paginación "),
                            _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("button", {
                                    class: "pagination-button",
                                    onClick: _cache[14] || (_cache[14] =
                                        //@ts-ignore
                                        (...args) => ($setup.prevPage2 && $setup.prevPage2(...args))),
                                    disabled: $setup.currentPage2 === 1
                                }, "Anterior", 8 /* PROPS */, _hoisted_107),
                                _createElementVNode("span", null, "Página " + _toDisplayString($setup.currentPage) + " de " + _toDisplayString($setup.totalPages2), 1 /* TEXT */),
                                _createElementVNode("button", {
                                    class: "pagination-button",
                                    onClick: _cache[15] || (_cache[15] =
                                        //@ts-ignore
                                        (...args) => ($setup.nextPage2 && $setup.nextPage2(...args))),
                                    disabled: $setup.currentPage2 === $setup.totalPages
                                }, "Siguiente", 8 /* PROPS */, _hoisted_108)
                            ]),
                            _createElementVNode("div", _hoisted_109, [
                                _createElementVNode("div", _hoisted_110, [
                                    _hoisted_111,
                                    _createElementVNode("span", _hoisted_112, _toDisplayString($setup.formatCurrency($setup.totalAmount)), 1 /* TEXT */)
                                ]),
                                _hoisted_113
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
            _createCommentVNode("/ End Shopping Item ")
        ], 512 /* NEED_PATCH */),
        _hoisted_114,
        _createCommentVNode(" End Header Area ")
    ], 64 /* STABLE_FRAGMENT */));
}
